import { tv } from "../../variants/tv.js";
const popupHeaderVariants = tv({
    slots: {
        root: [
            'relative sticky top-0 isolate flex min-h-14 [transform:translateZ(0)] items-center bg-neutral-1',
            'rounded-tl-[var(--popup-corner-t,0)] rounded-tr-[var(--popup-corner-t,0)] py-2 pr-15 pl-4'
        ],
        content: 'flex flex-1 flex-col gap-0.5 py-1',
        title: 'line-clamp-2 text-heading4 text-neutral-13',
        description: 'text-body3 text-neutral-11',
        closeButton: 'absolute top-3 right-3 z-[4]',
        scrim: ''
    },
    variants: {
        size: {
            sm: {
                root: 'min-h-12',
                title: 'text-heading5'
            },
            md: {
                root: 'min-h-14',
                title: 'text-heading4'
            },
            lg: {
                root: 'min-h-16',
                title: 'text-heading3'
            }
        },
        dividerTop: {
            true: {
                root: 'border-b border-b-neutral-5'
            },
            false: {}
        },
        inset: {
            true: {
                root: 'pl-6'
            },
            false: {}
        },
        scrim: {
            true: {
                root: 'bg-transparent'
            },
            false: {}
        }
    },
    defaultVariants: {
        size: 'md',
        dividerTop: false,
        inset: false,
        scrim: false
    }
});
export { popupHeaderVariants };
